const currentSeason = () => {
  const today = new Date()
  const currentMonth = today.getMonth()
  let season

  if (currentMonth > 2 && currentMonth < 10) {
    season = 'summer'
  } else {
    season = 'winter'
  }
  return season
}

export default currentSeason
